import { http } from "../api/http";

export const permissionGroupPermissionService = {
  getPermissionsForGroup,
  getGroupsForPermission,
  assign,
  remove,
};

async function getPermissionsForGroup(groupId) {
  let url = `/permissiongrouppermission/group/${groupId}`;

  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function getGroupsForPermission(permissionId) {
  let url = `/permissiongrouppermission/permission/${permissionId}`;
  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function assign(data) {
  let url = "/permissiongrouppermission";
  return await http.post(url, data).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function remove(groupId, permissionId) {
  let url = `/permissiongrouppermission?groupId=${groupId}&permissionId=${permissionId}`;
  return await http.delete(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}
